var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"mass-adjustment"},[_vm._m(0),_c('add-fundraising',{attrs:{"massAdjustment":true},on:{"alertUser":(result, message) => {this.$emit('alertUser', result, message);}}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageHeading"},[_c('h1',[_vm._v("Mass Adjustment")])])
}]

export { render, staticRenderFns }